import type React from "react";
import MarkdownIt from "markdown-it";
import DOMPurify from "dompurify";

interface FileResultRendererMDProps {
  result: string;
}

const mdParser = new MarkdownIt({
  html: true,
  breaks: true,
  linkify: true,
});

export const FileResultRendererMD: React.FC<FileResultRendererMDProps> = ({
  result,
}) => {
  const html = (): string => {
    const html = mdParser.render(result);
    return DOMPurify.sanitize(html);
  };

  return (
    <div
      dangerouslySetInnerHTML={{ __html: html() }}
      className="editor-markdown"
    />
  );
};
